import { useMutation, useQueryClient } from '@tanstack/react-query';

import useApi from '@/hooks/useApi/useApi';
import { queryKeys } from '@/lib/queryKeys';
import { TaskCategory } from '@/types/types';

export const useCreateTaskCategory = () => {
  const { axiosInstance } = useApi();
  const queryClient = useQueryClient();
  return useMutation<TaskCategory, unknown, { name: string }>({
    mutationFn: async ({ name }) => {
      const { data } = await axiosInstance.post<TaskCategory>('/api/v1/task_categories', {
        task_category: { name },
      });
      return data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: queryKeys.taskCategories._def });
    },
  });
};

export default useCreateTaskCategory;
